import type { SupabaseClient } from '@supabase/supabase-js'
import type { Database } from '@/types/database'

/** Fila de la vista vista_gastos_mensuales (no está en database.ts; se castea). */
export interface GastoMensualRow {
  organizacion_id: string
  categoria_id: string | null
  categoria: string
  color: string | null
  categoria_tipo: string // 'gasto' | 'retiro' | 'ingreso'
  grupo_resultado: string | null // 'operativo' | 'comercial' | 'administrativo' | 'financiero' | null (ORR-144)
  moneda: string
  mes_anio: string // 'YYYY-MM'
  total: number
  cantidad: number
}

/**
 * Servicio del reporte de gastos internos del estudio.
 * Aislamiento multi-tenant a nivel app: SIEMPRE filtra por organizacion_id (C4).
 */
export const gastosReporteService = {
  async obtenerGastosMensuales(
    client: SupabaseClient<Database>,
    organizacionId: string,
    desde?: string, // 'YYYY-MM' inclusive
  ): Promise<GastoMensualRow[]> {
    let query = client
      // La vista no está tipada en database.ts → cast a any para el from().
      .from('vista_gastos_mensuales' as never)
      .select('*')
      .eq('organizacion_id', organizacionId)
      .order('mes_anio', { ascending: true })

    if (desde) {
      query = query.gte('mes_anio', desde)
    }

    const { data, error } = await query
    if (error) throw error

    // Normalizar tipos numéricos (Postgres devuelve numeric como string).
    return ((data ?? []) as unknown as GastoMensualRow[]).map((r) => ({
      ...r,
      total: Number(r.total) || 0,
      cantidad: Number(r.cantidad) || 0,
    }))
  },
}
